
import Input from "../Input";
import Output from "../Output";

import switchImage from "../../assets/switch.png";
import { Helmet } from 'react-helmet-async';
import { Link } from "react-router-dom";

import norveg from "../../assets/norveg.png"
import magyar from "../../assets/magyar.png"
import arrow from "../../assets/arrow.png"

function MagyarNorveg({ handleText, output, handleTarget, handleSource, langs, handleSwap, handleTranslate, text }) {


    return (

        <>
            <Helmet>
                <title>Magyar norvég fordító</title>
                <meta name='description' content="Ingyenes magyar norvég fordító szavakra, kifejezésekre, mondatokra. Akár teljes szöveg fordítása is." />
                <meta title="Magyar norvég fordító" />
                <link rel="canonical" href="https://online-fordito.hu/magyar-norveg-fordito" />
            </Helmet>
            <h1>Magyar norvég fordító</h1>
            <div className="wrapper">
                <div>
                    <Input handleText={handleText} handleSource={handleSource} langs={langs} text={text}></Input>
                    <button className="transbutton" onClick={handleTranslate}>Fordítás</button>
                </div>

                <button className="switch" onClick={handleSwap}><img src={switchImage}></img></button>


                <Output output={output} handleTarget={handleTarget} langs={langs} />

            </div>

            <section>


                <div className="sectionhead">
                    <h2>A magyar és norvég nyelv </h2>
                    <img src={magyar} alt="magyar zászló"></img>
                    <img src={norveg} alt="norvég zászló"></img>
                </div>


                <p>A magyar ugor-altaikus nyelvcsaládba, míg a norvég a germán nyelvek csoportjába tartozik.</p>

                <h3>Hasonlóságok</h3>

                <ul>
                    <li><b>Hangrendszerek</b>: Mind a magyar, mind a norvég nyelv rendelkezik hangrendszerekkel. A magyarban a szavakat magas és mély hangrendekre osztjuk, míg a norvégnak is van magas és mély hangrendszer.</li>

                    <li><b>Ragozás</b>: Mind a magyar, mind a norvég nyelv gazdag ragozású nyelvek. Mindkét nyelvben a szavaknak többféle alakja van a különböző esetekben, számokban vagy névmódokban.</li>

                    <li><b>Szórend</b>: Általában mind a magyar, mind a norvég nyelvben az alany-állítmány-tárgy (AAT) szórend a leggyakoribb, bár mindkét nyelvben lehetnek eltérések és kivételek.</li>

                    <li><b>Szókincs</b>: Bár a magyar és a norvég nyelvnek eltérő szókincse van, vannak közös szavak és kifejezések is, amelyek a két nyelv közötti történelmi kapcsolatokra vagy kölcsönhatásokra utalhatnak.</li>
                </ul>

                <h3>Különbségek</h3>

                <ul>
                    <li><b>Nyelvcsalád és rokonság</b>: A magyar ugor-altaikus, míg a norvég indoeurópai nyelvcsaládba, a germán nyelvek csoportjába tartozik. Ez azt jelenti, hogy a két nyelvnek eltérő eredete és nyelvtörténete van.</li>

                    <li><b>Hangzások és kiejtés</b>: A magyar és a norvég nyelvnek eltérő hangzásai és fonetikai rendszerei vannak. A norvégnak például olyan hangzói vannak, amelyek a magyarban nem találhatók meg, és fordítva.</li>

                    <li><b>Nyelvtani struktúra</b>: A magyar és a norvég nyelv nyelvtani struktúrája is eltérő. A norvégnak például más jelzőragok, névmások és igék használata lehet, mint a magyarnak.</li>

                    <li><b>Írásrendszer</b>: A magyar nyelv latin betűs írásrendszert használ, míg a norvégban az ún. norvég ábécét alkalmazzák, amely a latin betűket kiegészíti néhány saját karakterrel.</li>
                </ul>

                <div className="sectionbottom">
                    <Link to="/norveg-magyar-fordito">Norvég magyar fordító</Link>
                    <img src={norveg} alt="norvég zászló"></img>
                    <img src={arrow} alt=">"></img>
                    <img src={magyar} alt="magyar zászló"></img>
                </div>
            </section>
        </>

    )
}

export default MagyarNorveg;